// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

$(() => {
  if ($(document.body).attr('data-environment') === 'test') {
    // Disable animations globally so Capybara doesn't see duplicate elements during transitions
    up.motion.config.enabled = false
    // When revealing elements, don't animate the scrolling
    up.viewport.config.duration = 0
  }
})
